import { useEffect, useRef, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.css";
import "./screen.css";
import { MqttContext } from "../mqtt/MqttContext";
import Loader from "./Loader";
import axios from "axios";
import Sidebar from "./SideBar";
const API_URL = process.env.REACT_APP_API_URL;
function Mac() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState(""); // 🔍 NEW
  const [loading, setloading] = useState(true);
  const [noDevices, setNoDevices] = useState(false);
  const { subscribe, publish } = useContext(MqttContext);
  useEffect(() => {
    subscribe(`dssp/deviceData/#`);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (!location?.state?.role) {
      navigate("/dashboard");
    }
    // eslint-disable-next-line
  }, [location]);

  const [data, setdata] = useState([]);
  const pauseRefresh = useRef(false);

  const [currentRole, setCurrentRole] = useState("");
  const getmac = async () => {
    const userId = location.state?.userId || localStorage.getItem("loginId");
    // console.log(
    //   userId,
    //   location.state?.userId,
    //   localStorage.getItem("loginId")
    // );
    const role = localStorage.getItem("role") || location.state?.role;
    setCurrentRole(role);

    fetch(`${API_URL}/index.php?getmac=true`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {

        let relevantDevices = responseData;

        // Filter devices by user ID if passed from another page
        if (role === "User") {
          if (userId) {
            relevantDevices = responseData.filter(
              (device) => device.userid === userId
            );
          }
        } else {
          if (location.state?.userId) {
            relevantDevices = responseData.filter(
              (device) => device.userid === location.state?.userId
            );
          }
        }
        // Show message if no devices found
        if (relevantDevices.length === 0) {
          setNoDevices(true); // NEW STATE TO TRIGGER UI MESSAGE
        } else {
          setNoDevices(false);
        }

        setdata(relevantDevices);

        // Set toggle states
        const initialStates = {};
        relevantDevices?.forEach((device) => {
          initialStates[device.mac_address] = {
            rs485: device.rs485 === "true",
            dosing: device.dosing === "true",
            rs4852: device.rs4852 === "true",
            dosing2: device.dosing2 === "true",
            sandfilter: device.sand_filter === "true",
            enable: device.enable === "true",
            chlorine: device.rs4852 === "true",
            copper: device.copper === "true",
            chl_cu: device.chl_cu === "true",
            circ_pump: device.circ_pump === "true",
            circ_threshold: device.circ_threshold,
            circ_current: device.circ_current,
            notification: device.notification === "true",
            whatsapp: device.whatsapp === "true",
            sms: device.sms === "true",
            wifi: device.wifi === 1 || device.wifi === "1" ? "C" : "D",
            ble: device.ble === 1 || device.ble === "1" ? "C" : "D",
            ota_version: device.ota_version,
            ota_status: device.ota_status,
            wifi_ssid: device.wifi_ssid,
            wifi_password: device.wifi_password,
            online: device.online === "true",
            byepass: device.bypass_mode === "true",
            cellular: device.cellular_mode === "true",
            apn: device.apn || "internet",
            name: device.name || "",
          };
        });

        setToggleStates(initialStates);
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
      });
  };
  useEffect(() => {
    getmac();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (!pauseRefresh.current) getmac();
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);
  const publishdata2 = (command, mac) => {
    publish(`dssp/settings/${mac?.trim()}`, command, { qos: 1 });
  };
  const [wifiModalOpen, setWifiModalOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [wifiData, setWifiData] = useState({
    ssid: "",
    password: "",
  });
  const openWifiModal = (device) => {
    setSelectedDevice(device);
    setWifiData({
      ssid: device?.app_ssid || "",
      password: device?.app_password || "",
    });
    setWifiModalOpen(true);
  };
  const updateWifiCredentials = async () => {
    try {
      const res = await fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          wifi_mac: selectedDevice.mac_address,
          wifi_ssid: wifiData.ssid,
          wifi_password: wifiData.password,
        }),
      });

      const data = await res.json();
      if ((data.status = "Updated")) {
        alert("WiFi updated!");
        setWifiModalOpen(false);
      } else {
        alert("Failed to update WiFi");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const filteredDevice = data.filter(
    (user) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.mac_address.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [toggleStates, setToggleStates] = useState({});

  const handleToggle = (index, key, value, extraUpdates = {}
    ) => {
    pauseRefresh.current = true;
    // const updatedState = {
    //   ...toggleStates[index],
    //   [key]: value,
    // };

    // // Update React state
    // setToggleStates((prev) => ({
    //   ...prev,
    //   [index]: updatedState,
    // }));
    const updatedState = {
      ...toggleStates[index],
      [key]: value,
      ...extraUpdates,
    };
  
    setToggleStates((prev) => ({
      ...prev,
      [index]: updatedState,
    }));
    // Publish MQTT with correct updated value
    publishdata2(
      JSON.stringify({
        "Setting": {
          "Device": updatedState.enable?.toString(),
          "PH": updatedState.rs485?.toString(),
          Chl: updatedState.rs4852?.toString(),
          Cu: updatedState.copper?.toString(),
          "Acid_Dos": updatedState.dosing?.toString(),
          "Other_Dos": updatedState.dosing2?.toString(),
          "Chl/Cu_Dos": updatedState.chl_cu?.toString(),
          "SandFilter": updatedState.sandfilter?.toString(),
          "ByPass": updatedState.byepass?.toString(),
          "Cellular": updatedState.cellular?.toString(),
          SIM: updatedState.sim?.toString(),
          "WiFi": (!updatedState.sim)?.toString(),
          APN: updatedState.apn?.toString(),
         // "Circ Pump": updatedState.circ_pump?.toString(),
        //  "Circ Current": updatedState.circ_current?.toString(),
        //  "Circ Threshold": updatedState.circ_threshold?.toString(),
          name: updatedState.name?.toString(),
        },
      }),
      index
    );
    if (key === "rs485") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          RS485: value?.toString(),
          RS485_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "enable") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          enable: value?.toString(),
          mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "chlorine") {
      if (value === true) {

      }
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          RS4852: value?.toString(),
          RS4852_mac: index,
          copper: "false",
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (key === "copper") {
      if (value === true) {
     
      }
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          RS4852: "false",
          RS4852_mac: index,
          copper: value?.toString(),
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (key === "sandfilter") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          SandFilter: value?.toString(),
          SandFilter_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "dosing") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Dosing: value?.toString(),
          Dosing_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "dosing2") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Dosing2: value?.toString(),
          Dosing2_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "chl_cu") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chl_cu: value?.toString(),
          chl_cu_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "circ_pump") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          circ_pump: value?.toString(),
          circ_pump_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "notification") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          notification: value?.toString(),
          notification_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {

        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "sms") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sms: value?.toString(),
          sms_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "whatsapp") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          whatsapp: value?.toString(),
          whatsapp_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "byepass") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          byepass_mode: value?.toString(),
          byepass_mode_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (key === "cellular") {
      fetch(`${API_URL}/settings.php`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cellular_mode: value?.toString(),
          cellular_mode_mac: index,
        }),
      })
        .then((response) => response.json())
        .then((responseData) => {
        })
        .catch((err) => {
          console.log(err);
        });
    }
    setTimeout(() => (pauseRefresh.current = false), 6000); // resume after 3 sec
  };

  const deletedevice = async (id) => {
    fetch(`${API_URL}/index.php?deletemac=${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        getmac();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [selected, setSelected] = useState(null);
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    setloading(true);
    if (file) {
      // const name = localStorage.getItem("loginname");
      const formData = new FormData();
      formData.append("file", file);

      // Step 1: Upload file
      try {
       await axios.post(
          `${API_URL}/test.php?mac=${selected}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        window.alert("File uploaded");
        setloading(false);
      } catch (error) {
        console.error("Error uploading file:", error);
      }

      // Step 2: Read XLSX file
      const reader = new FileReader();
      reader.onload = async (e) => {
        // const binaryStr = e.target.result;
      };

      reader.readAsBinaryString(file);
    }
  };
  return (
    <>
      <div style={{ display: "flex", height: "100vh", width: "100%" }}>
        {/* Sidebar */}
        <Sidebar />
        {/* Main Content */}
        <div
          style={{
            flex: 1,
            padding: "30px",
            backgroundColor: "#fff",
            overflow: "hidden", // prevent double scrolls
            paddingTop: "10px",
          }}
        >
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: "10px",
              marginBottom: "10px",
              width: "100%",
              maxWidth: "400px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              fontSize: "14px",
              height: "40px",
              maxHeight: "40px",
            }}
          />
          {/* Conditional Rendering: Table for Devices */}
          {loading ? (
            <div
              style={{
                width: "100%",
                height: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader message="Please Wait..." />
            </div>
          ) : noDevices ? (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                color: "black",
                textAlign: "center",
                marginTop: "10%",
              }}
            >
              No device allocated for this user.
            </div>
          ) : location?.state?.role === "Devices" ? (
            <div className="table-wrapper">
              <div className="table-container">
                <table>
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#489ff6",
                      color: "#fff",
                      zIndex: 2,
                    }}
                  >
                    <tr
                      style={{
                        backgroundColor: "#489ff6",
                        color: "#fff",
                        textAlign: "left",
                      }}
                    >
                      <th style={{ padding: "12px 16px" }}>Device Name</th>
                      <th style={{ padding: "12px 16px" }}>MAC Address</th>
                      <th style={{ padding: "12px 16px" }}>User</th>
                      <th style={{ padding: "12px 16px" }}>Status</th>

                      <>
                        {currentRole !== "User" ? (
                          <>
                            <th style={{ padding: "12px 16px" }}>Delete</th>
                            {localStorage.getItem("role") ===
                              "Product Manager" && (
                              <th style={{ padding: "12px 16px" }}>Enable</th>
                            )}
                          </>
                        ) : null}
                        <th style={{ padding: "12px 16px" }}>Byepass Mode</th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                          }}
                        >
                          Sensor
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 8,
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                paddingTop: 10,
                                paddingBottom: 10,
                              }}
                            >
                              PH/ORP/TEMP
                            </div>
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                paddingTop: 10,
                                paddingBottom: 10,
                              }}
                            >
                              Chlorine / Copper
                            </div>
                          </div>
                        </th>

                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                          }}
                        >
                          Dosing
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 8,
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              Acid
                            </div>
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              CHL/CU
                            </div>
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              Others
                            </div>
                          </div>
                        </th>

                        <th
                          style={{
                            padding: "12px 16px",
                            boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                          }}
                        >
                          Sand Filter
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                          }}
                        >
                          CirC Pump
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 8,
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              On/Off
                            </div>
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              Current
                            </div>
                            {localStorage.getItem("role") === "User" ? null : (
                              <div
                                style={{
                                  flex: 1,
                                  border: "1px solid #fff",
                                  padding: 10,
                                }}
                              >
                                Threshold
                              </div>
                            )}
                          </div>
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                          }}
                        >
                          Notification
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 8,
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              Pop-Up
                            </div>

                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              SMS
                            </div>

                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #fff",
                                padding: 10,
                              }}
                            >
                              Whatsapp
                            </div>
                          </div>
                        </th>
                        {localStorage.getItem("role") !== "Product Manager" &&
                        localStorage.getItem("role") !==
                          "Site Manager" ? null : (
                          <th
                            style={{
                              padding: "12px 16px",
                              boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                            }}
                          >
                            Wifi
                          </th>
                        )}
                        {localStorage.getItem("role") !== "Product Manager" &&
                        localStorage.getItem("role") !==
                          "Site Manager" ? null : (
                          <th
                            style={{
                              padding: "12px 16px",
                              boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                            }}
                          >
                            Ble
                          </th>
                        )}
                        {localStorage.getItem("role") !== "Product Manager" &&
                        localStorage.getItem("role") !==
                          "Site Manager" ? null : (
                          <th
                            style={{
                              padding: "12px 16px",
                              boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                            }}
                          >
                            Cellular
                          </th>
                        )}
                        <th
                          style={{
                            padding: "12px 16px",
                            boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                          }}
                        >
                          OTA Version
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                          }}
                        >
                          OTA Status
                        </th>
                        <th
                          style={{
                            padding: "12px 16px",
                            boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                          }}
                        >
                          Upload OTA
                        </th>
                      </>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredDevice?.map((device, index) => {
                      const handleDeviceClick = () => {
                        const toggles = toggleStates[device.mac_address] || {};
                        const isAnyEnabled =
                          toggles.rs485 ||
                          toggles.rs4852 ||
                          toggles.chlorine ||
                          toggles.chl_cu ||
                          toggles.copper ||
                          toggles.dosing ||
                          toggles.dosing2 ||
                          toggles.sandfilter;

                        if (!isAnyEnabled) {
                          alert(
                            "Please enable at least one option before proceeding."
                          );
                          return;
                        }

                        navigate("/settings", {
                          state: {
                            id: device?.mac_address,
                          },
                        });
                      };

                      return (
                        <tr
                          key={index}
                          style={{
                            borderBottom: "1px solid #eee",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#dde8ed";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                          }}
                        >
                          <td
                            onClick={handleDeviceClick}
                            style={{ padding: "12px 16px" }}
                          >
                            {device.name || "N/A"}
                          </td>
                          <td
                            onClick={handleDeviceClick}
                            style={{ padding: "12px 16px" }}
                          >
                            {device.mac_address || "N/A"}
                          </td>
                          <td
                            onClick={handleDeviceClick}
                            style={{ padding: "12px 16px" }}
                          >
                            {device.email || "N/A"}
                          </td>
                          <td
                            onClick={handleDeviceClick}
                            style={{ padding: "12px 16px", display: "flex" }}
                          >
                            <span
                              style={{
                                padding: "4px 10px",
                                borderRadius: 6,
                                backgroundColor: device.userid
                                  ? "#d4edda"
                                  : "#f8d7da",
                                fontSize: "0.6rem",
                                color: device.userid ? "#155724" : "#721c24",
                              }}
                            >
                              {device.userid ? "Assigned" : "Not_Assigned"}
                            </span>
                            <div
                              style={{
                                width: "13px",
                                height: "13px",
                                borderRadius: "50%",
                                backgroundColor: toggleStates[
                                  device.mac_address
                                ]?.online
                                  ? "#28a745"
                                  : "#e50000",
                                border: "2px solid white",
                                boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                                marginTop: "5px",
                                marginLeft: "2px",
                              }}
                            />
                          </td>

                          <>
                            {currentRole !== "User" ? (
                              <>
                                <td
                                  onClick={() => {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to delete this device?"
                                      )
                                    ) {
                                      deletedevice(device.mac_address);
                                    }
                                  }}
                                  style={{ padding: "12px 16px" }}
                                >
                                  <center>
                                    <img
                                      src={require("../img/delete.png")}
                                      style={{ width: "20px", height: "20px" }}
                                      alt="edit"
                                    />
                                  </center>
                                </td>
                                {localStorage.getItem("role") ===
                                "Product Manager" ? (
                                  <td style={{ padding: "12px 16px" }}>
                                    <label className="toggle-switch">
                                      <input
                                        type="checkbox"
                                        checked={
                                          toggleStates[device.mac_address]
                                            ?.enable || false
                                        }
                                        onChange={(e) =>
                                          handleToggle(
                                            device.mac_address,
                                            "enable",
                                            e.target.checked
                                          )
                                        }
                                      />
                                      <span className="slider"></span>
                                    </label>
                                  </td>
                                ) : null}
                              </>
                            ) : null}
                            <td style={{ padding: "12px 16px" }}>
                              <label className="toggle-switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    toggleStates[device.mac_address]?.byepass ||
                                    false
                                  }
                                  onChange={(e) =>
                                    handleToggle(
                                      device.mac_address,
                                      "byepass",
                                      e.target.checked
                                    )
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </td>
                            <td
                              style={{
                                padding: "12px 16px",
                                boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                }}
                              >
                                <div
                                  style={{
                                    width: "90px",
                                    justifyContent: "space-around",
                                    display: "flex",
                                  }}
                                >
                                  <label className="toggle-switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        toggleStates[device.mac_address]
                                          ?.rs485 || false
                                      }
                                      onChange={(e) => {
                                        // handleToggle(
                                        //   device.mac_address,
                                        //   "rs485",
                                        //   e.target.checked
                                        // );
                                        // if (e.target.checked) {
                                        //   handleToggle(
                                        //     device.mac_address,
                                        //     "chlorine",
                                        //     !e.target.checked
                                        //   );
                                        // }
                                        handleToggle(device?.mac_address, 'rs485', e.target.checked, {
                                          chlorine: false,
                                        });
                                      }}
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                                <div
                                  style={{
                                    width: "130px",
                                    justifyContent: "space-around",
                                    display: "flex",
                                  }}
                                >
                                  <label className="toggle-switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        toggleStates[device.mac_address]
                                          ?.chlorine || false
                                      }
                                      onChange={(e) => {
                                        // handleToggle(
                                        //   device.mac_address,
                                        //   "chlorine",
                                        //   e.target.checked
                                        // );
                                        // if (e.target.checked) {
                                        //   handleToggle(
                                        //     device.mac_address,
                                        //     "rs485",
                                        //     !e.target.checked
                                        //   );
                                        // }
                                        handleToggle(device?.mac_address, 'chlorine', e.target.checked, {
                                          rs485: false,
                                          copper:false
                                        });
                                      }}
                                    />
                                    <span
                                      style={{
                                        backgroundColor: toggleStates[
                                          device.mac_address
                                        ]?.chlorine
                                          ? "#DCE775" // ON color
                                          : "#ccc", // OFF color
                                      }}
                                      className="slider"
                                    ></span>
                                  </label>
                                  <label className="toggle-switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        toggleStates[device.mac_address]
                                          ?.copper || false
                                      }
                                      onChange={(e) =>
                                        // handleToggle(
                                        //   device.mac_address,
                                        //   "copper",
                                        //   e.target.checked
                                        // )
                                        handleToggle(device?.mac_address, 'copper', e.target.checked, {
                                          chlorine: false,
                                        })
                                      }
                                    />
                                    <span
                                      style={{
                                        backgroundColor: toggleStates[
                                          device.mac_address
                                        ]?.copper
                                          ? "#B87333" // ON color
                                          : "#ccc", // OFF color
                                      }}
                                      className="slider"
                                    ></span>
                                  </label>
                                </div>
                              </div>
                            </td>
                            {localStorage.getItem("role") === "User" ? (
                              <td
                                style={{
                                  padding: "12px 16px",
                                  boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  <label className="toggle-switch">
                                    <div
                                      style={{
                                        width: "3vh",
                                        height: "3vh",
                                        borderRadius: "50%",
                                        backgroundColor: toggleStates[
                                          device.mac_address
                                        ]?.dosing
                                          ? "#28a745"
                                          : "#ccc",
                                        border: "2px solid white",
                                        boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </label>
                                  <label className="toggle-switch">
                                    <div
                                      style={{
                                        width: "3vh",
                                        height: "3vh",
                                        borderRadius: "50%",
                                        backgroundColor: toggleStates[
                                          device.mac_address
                                        ]?.chl_cu
                                          ? "#28a745"
                                          : "#ccc",
                                        border: "2px solid white",
                                        boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </label>
                                  <label className="toggle-switch">
                                    <div
                                      style={{
                                        width: "3vh",
                                        height: "3vh",
                                        borderRadius: "50%",
                                        backgroundColor: toggleStates[
                                          device.mac_address
                                        ]?.dosing2
                                          ? "#28a745"
                                          : "#ccc",
                                        border: "2px solid white",
                                        boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                                        marginTop: "5px",
                                      }}
                                    />
                                  </label>
                                </div>
                              </td>
                            ) : (
                              <td
                                style={{
                                  padding: "12px 16px",
                                  boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  <label className="toggle-switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        toggleStates[device.mac_address]
                                          ?.dosing || false
                                      }
                                      onChange={(e) => {
                                        handleToggle(
                                          device.mac_address,
                                          "dosing",
                                          e.target.checked
                                        );
                                      }}
                                    />
                                    <span className="slider"></span>
                                  </label>
                                  <label className="toggle-switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        toggleStates[device.mac_address]
                                          ?.chl_cu || false
                                      }
                                      onChange={(e) =>
                                        handleToggle(
                                          device.mac_address,
                                          "chl_cu",
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="slider"></span>
                                  </label>
                                  <label className="toggle-switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        toggleStates[device.mac_address]
                                          ?.dosing2 || false
                                      }
                                      onChange={(e) =>
                                        handleToggle(
                                          device.mac_address,
                                          "dosing2",
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="slider"></span>
                                  </label>
                                </div>
                              </td>
                            )}

                            <td
                              style={{
                                padding: "12px 16px",
                                boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                              }}
                            >
                              <center>
                                <label className="toggle-switch">
                                  <input
                                    type="checkbox"
                                    checked={
                                      toggleStates[device.mac_address]
                                        ?.sandfilter || false
                                    }
                                    onChange={(e) => {
                                      handleToggle(
                                        device.mac_address,
                                        "sandfilter",
                                        e.target.checked
                                      );
                                      handleToggle(
                                        device.mac_address,
                                        "circ_pump",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </center>
                            </td>

                            <td style={{}}>
                              {toggleStates[device.mac_address]?.sandfilter ? (
                                <div
                                  style={{
                                    display: "flex",
                                    padding: "0x 16px",
                                    justifyContent: "space-around",
                                    marginTop: "10px",
                                  }}
                                >
                                  <label className="toggle-switch">
                                    <input
                                      type="checkbox"
                                      checked={
                                        toggleStates[device.mac_address]
                                          ?.circ_pump || false
                                      }
                                      onChange={(e) =>
                                        handleToggle(
                                          device.mac_address,
                                          "circ_pump",
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="slider"></span>
                                  </label>
                                  <label>
                                    <p style={{ color: "#000" }}>
                                      {toggleStates[device.mac_address]
                                        ?.circ_current || "--"}
                                    </p>
                                  </label>
                                  {localStorage.getItem("role") ===
                                  "User" ? null : (
                                    <label>
                                      <p style={{ color: "#000" }}>
                                        {toggleStates[device.mac_address]
                                          ?.circ_threshold || "--"}
                                      </p>
                                    </label>
                                  )}
                                </div>
                              ) : null}
                            </td>

                            <td
                              style={{
                                padding: "12px 16px",
                                boxShadow: "-4px 0 6px -2px rgba(0,0,0,0.3)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                }}
                              >
                                <div
                                  style={{
                                    width: "90px",
                                    justifyContent: "space-around",
                                    display: "flex",
                                  }}
                                >
                                  <center>
                                    <label className="toggle-switch">
                                      <input
                                        type="checkbox"
                                        checked={
                                          toggleStates[device.mac_address]
                                            ?.notification || false
                                        }
                                        onChange={(e) => {
                                          handleToggle(
                                            device.mac_address,
                                            "notification",
                                            e.target.checked
                                          );
                                        }}
                                      />
                                      <span className="slider"></span>
                                    </label>
                                  </center>
                                </div>

                                <div
                                  style={{
                                    width: "90px",
                                    justifyContent: "space-around",
                                    display: "flex",
                                  }}
                                >
                                  <center>
                                    <label className="toggle-switch">
                                      <input
                                        type="checkbox"
                                        checked={
                                          toggleStates[device.mac_address]
                                            ?.sms || false
                                        }
                                        onChange={(e) => {
                                          handleToggle(
                                            device.mac_address,
                                            "sms",
                                            e.target.checked
                                          );
                                        }}
                                      />
                                      <span className="slider"></span>
                                    </label>
                                  </center>
                                </div>

                                <div
                                  style={{
                                    width: "90px",
                                    justifyContent: "space-around",
                                    display: "flex",
                                  }}
                                >
                                  <center>
                                    <label className="toggle-switch">
                                      <input
                                        type="checkbox"
                                        checked={
                                          toggleStates[device.mac_address]
                                            ?.whatsapp || false
                                        }
                                        onChange={(e) => {
                                          handleToggle(
                                            device.mac_address,
                                            "whatsapp",
                                            e.target.checked
                                          );
                                        }}
                                      />
                                      <span className="slider"></span>
                                    </label>
                                  </center>
                                </div>
                              </div>
                            </td>
                            {localStorage.getItem("role") !==
                              "Product Manager" &&
                            localStorage.getItem("role") !==
                              "Site Manager" ? null : (
                              <td
                                onClick={() => openWifiModal(device)}
                                style={{ cursor: "pointer" }}
                              >
                                <label>
                                  <p
                                    style={{ color: "#000", cursor: "pointer" }}
                                  >
                                    {toggleStates[device.mac_address]?.wifi ||
                                      "--"}
                                  </p>
                                </label>
                              </td>
                            )}
                            {localStorage.getItem("role") !==
                              "Product Manager" &&
                            localStorage.getItem("role") !==
                              "Site Manager" ? null : (
                              <td style={{}}>
                                <label>
                                  <p style={{ color: "#000" }}>
                                    {toggleStates[device.mac_address]?.ble ||
                                      "--"}
                                  </p>
                                </label>
                              </td>
                            )}
                            {localStorage.getItem("role") !==
                              "Product Manager" &&
                            localStorage.getItem("role") !==
                              "Site Manager" ? null : (
                              <td style={{ padding: "12px 16px" }}>
                                <label className="toggle-switch">
                                  <input
                                    type="checkbox"
                                    checked={
                                      toggleStates[device.mac_address]
                                        ?.cellular || false
                                    }
                                    onChange={(e) =>
                                      handleToggle(
                                        device.mac_address,
                                        "cellular",
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </td>
                            )}
                            {localStorage.getItem("role") !==
                            "Product Manager" ? null : (
                              <td style={{}}>
                                <label>
                                  <p style={{ color: "#000" }}>
                                    {toggleStates[device.mac_address]
                                      ?.ota_version || "--"}
                                  </p>
                                </label>
                              </td>
                            )}
                            {localStorage.getItem("role") !==
                            "Product Manager" ? null : (
                              <td style={{}}>
                                <label>
                                  <p style={{ color: "#000" }}>
                                    {toggleStates[device.mac_address]
                                      ?.ota_status || "--"}
                                  </p>
                                </label>
                              </td>
                            )}
                            <td>
                              <label
                                onClick={() => {
                                  setSelected(device.mac_address);
                                }}
                                htmlFor="file-upload"
                                style={{
                                  cursor: "pointer",
                                  display: "block",
                                  margin: 0,
                                  color: "#fff",
                                }}
                              >
                                <img
                                  src={require("../img/upload.png")}
                                  alt="Toggle Graph"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    color: "#fff",
                                    cursor: "pointer",
                                    filter: "brightness(10) invert(100%)",
                                  }}
                                />
                              </label>
                              <input
                                id="file-upload"
                                type="file"
                                accept=".bin"
                                onChange={handleFileUpload}
                                style={{ display: "none" }}
                              />
                            </td>
                          </>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
          {wifiModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  width: "350px",
                }}
              >
                <h3>WiFi Settings</h3>

                <label style={{ fontWeight: "600" }}>WiFi SSID:</label>
                <input
                  type="text"
                  value={wifiData.ssid}
                  onChange={(e) =>
                    setWifiData({ ...wifiData, ssid: e.target.value })
                  }
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    fontSize: "14px",
                    minHeight: "40px",
                    paddingLeft: "10px",
                  }}
                />

                <label style={{ fontWeight: "600" }}>Password:</label>
                <input
                  type="text"
                  value={wifiData.password}
                  onChange={(e) =>
                    setWifiData({ ...wifiData, password: e.target.value })
                  }
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    fontSize: "14px",
                    minHeight: "40px",
                    paddingLeft: "10px",
                  }}
                />

                <button
                  onClick={updateWifiCredentials}
                  style={{
                    width: "100%",
                    padding: "10px",
                    background: "#489ff6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    marginTop: "10px",
                  }}
                >
                  Update WiFi
                </button>

                <button
                  onClick={() => setWifiModalOpen(false)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    background: "#489ff6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    marginTop: "10px",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default Mac;
